// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__NWsod","right":"styles_right__4pgT8"};